export default __webpack_public_path__ + "static/media/01.2856f901.jpg";